// extracted by mini-css-extract-plugin
export default {"resetButton":"A0q2N09","root":"y5qhdwE","preloader":"tQ1KOSn"};